'use strict';

var createjs = createjs || {};

createjs.RotateTransform = class RotateTransform extends createjs.BaseTransform {
	constructor(element) {
		super(element);

		this.el.borders.rotation = [];
		this.el.fraction.move.rotation = 1;
		this.el.fraction.release.rotation = 1;

		_.bindAll(this, '_holdBorders', '_dispatchTweenUpdate', '_dispatchRotationComplete');
	}


	get ROTATE() { return 'rotate'};
	get ROTATE_COMPLETE() { return 'rotateComplete'};

	_holdBorders(){
		if (! this.el.free.rotation) {
			if      (this.el.rotation < this.el.borders.rotation[0]) this.el.rotation = this.el.borders.rotation[0];
			else if (this.el.rotation > this.el.borders.rotation[1]) this.el.rotation = this.borders.rotation[1];
		}
	};

	_dispatchTweenUpdate(){
		this._holdBorders();

		if (this.lock || this.el.lock ) {
			this._stopTween();
		}

		this.el.dispatchEvent(this.ROTATE);
	};

	_startTransform(evt){
		if (this.el && this.el._activeFingers > 1) {
			this._stopTween();
		}
	};

	_dispatchRotationComplete(){
		this.el.dispatchEvent(this.ROTATE_COMPLETE);
	};

	_update(evt){
		if(this.debug) console.log('_update');

		if (this.lock || this.el.lock ) return;

		if (this.el._activeFingers > 1) {
			this._stopTween();

			var points = [];

			// extract touchpoints
			for (var k in this.el._fingers) {
				if (this.el._fingers[k].current) {
					points.push(this.el._fingers[k]);
					if (points.length >= 2) break;
				}
			}

			// calculate initial angle
			var point1 = points[0].old;
			var point2 = points[1].old;
			var startAngle = Math.atan2((point1.y - point2.y), (point1.x - point2.x)) * (180/Math.PI);

			// calculate new angle
			var point1 = points[0].current;
			var point2 = points[1].current;
			var currentAngle = Math.atan2((point1.y - point2.y), (point1.x - point2.x)) * (180/Math.PI);

			// set rotation based on difference between the two angles
			this.el.rotation += ((currentAngle - startAngle) * this.el.fraction.move.rotation * this.el.fraction.base);
			if(this.debug) console.log('rotate', this.el.rotation);
			this._holdBorders();

			this.el.dispatchEvent(this.ROTATE);
		}
	};

	_stopTransform(evt){
		if (this.lock || this.el.lock ) return;

		if (this.el._stack.length == 0 || typeof TweenLite === 'undefined' || !this.useTween) {
			this._dispatchRotationComplete();
		} else if (! (typeof TweenLite === 'undefined')) {
			var options = {};
			var average = {rotation: 0};

			for (var i = 1, _len = this.el._stack.length; i < _len; i++) {
				average.rotation += (this.el._stack[i].rotation - this.el._stack[i-1].rotation);
			}

			average.rotation = average.rotation / this.el._stack.length;

			var fade = 10;

			var speed = 1 * this.el.fraction.release.rotation * this.el.fraction.base;

			options.rotation = this.el.rotation + average.rotation * this.el.fraction.release.rotation * this.el.fraction.base * fade;

			if (this.el.snap.rotation && this.el.snap.rotation != 0) {
				options.rotation = (Math.round(options.y / this.el.snap.rotation) * this.el.snap.rotation);
			}

			if (! this.el.free.rotation) {
				if      (options.rotation < this.el.borders.rotation[0]) options.rotation = this.el.borders.rotation[0];
				else if (options.rotation > this.el.borders.rotation[1]) options.rotation = this.el.borders.rotation[1];
			}

			options.ease = Cubic.easeOut;
			options.onComplete = this._dispatchRotationComplete;
			options.onUpdate = this._dispatchTweenUpdate;
			options.overwrite = 'auto';

			this._stopTween();
			this._tween = TweenLite.to(this.el, speed, options);
		}
	};
}